var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.43 79.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5656ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.76,47.57a26,26,0,0,0,7,16.63,1.1,1.1,0,0,1,.17-.25,24.73,24.73,0,0,0,7.26-16.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.55,27.22a26.93,26.93,0,0,1,7.87,18.1h8.19V20.91a1.12,1.12,0,0,1,.09-.44A25.9,25.9,0,0,0,16.37,27.1,1.13,1.13,0,0,1,16.55,27.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.61,47.57H24.42a26.94,26.94,0,0,1-7.92,18,1.25,1.25,0,0,1-.24.16A25.89,25.89,0,0,0,32.7,72.42a1,1,0,0,1-.09-.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.86,45.32h9.85a27.09,27.09,0,0,1,7.2-17.39l0,0a26,26,0,0,0-17.18-7.43,1.12,1.12,0,0,1,.09.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.71,45.32a25.88,25.88,0,0,0-6.23-15.77A24.75,24.75,0,0,0,47,45.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,28.81a.86.86,0,0,1-.13-.2A25.89,25.89,0,0,0,7.76,45.32H22.17A24.71,24.71,0,0,0,15,28.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.72,47.57H34.86V72a1,1,0,0,1-.09.44,25.91,25.91,0,0,0,17.32-7.56,1.3,1.3,0,0,1-.31-.21A27,27,0,0,1,44.72,47.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.44,63.13c.05,0,.06.1.1.16a26,26,0,0,0,6.17-15.72H47A24.84,24.84,0,0,0,53.44,63.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeporte);
export default __webpack_public_path__ + "static/media/Icon-deporte.df4e632f4f789c1dac0ca9ef3b6d7d44.svg";
export { ForwardRef as ReactComponent };